import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { m, LazyMotion, domAnimation } from "framer-motion";
import step1 from "../Image/SS/sign-up.jpg";
import step2 from "../Image/SS/sign-in.jpg";
import step3 from "../Image/SS/profile-setup.jpg";
import step4 from "../Image/SS/update_profile.jpg";
import step5 from "../Image/SS/mala-gallary.jpg";
import step6 from "../Image/SS/invite-img.jpg";
import step7 from "../Image/SS/Rewards-Tasks.jpg";
import step8 from "../Image/SS/trackMalaCount.jpg";
import step9 from "../Image/SS/collect_fram.jpg";

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    { img: step1, id: 1 },
    { img: step2, id: 2 },
    { img: step3, id: 3 },
    { img: step4, id: 4 },
    { img: step5, id: 5 },
    { img: step6, id: 6 },
    { img: step7, id: 7 },
    { img: step8, id: 8 },
    { img: step9, id: 9 },
  ];

  const stepVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <LazyMotion features={domAnimation}>
      <Container className="my-5" id="howItWorks">
        <m.h2
          className="text-center mb-4 feature-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          style={{ color: "var(--primary-color)", willChange: "opacity" }}
        >
          {t("howItWorksPage.title")}
        </m.h2>

        <Row className="d-flex justify-content-center">
          {steps.map((step, index) => {
            const isEven = (index + 1) % 2 === 0;

            return (
              <m.div
                key={step.id}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                variants={stepVariants}
                className="w-100"
                style={{ willChange: "opacity" }}
              >
                <section className="py-3 py-md-4 py-sm-4">
                  <div className="container px-3 p-lg-0">
                    <div className="row justify-content-between align-items-center">
                      {/* Text Column */}
                      <Col
                        lg={6}
                        md={6}
                        xs={12}
                        className={`How_it_work_text_sec mt-4 mt-md-0 ${isEven ? "order-lg-2 order-md-2 order-2" : "order-lg-1 order-md-1 order-2"
                          }`}
                      >
                        <h4
                          className="mb-3 howWorktxt1 fw-semibold"
                          style={{ color: "var(--text-dark)" }}
                        >
                          {t(`howItWorksPage.step${step.id}.title`)}
                        </h4>
                        <p
                          className="howWorktxt2 m-0"
                          style={{ color: "var(--text-light)" }}
                        >
                          {t(`howItWorksPage.step${step.id}.description`)}
                        </p>
                      </Col>

                      {/* Image Column */}
                      <Col
                        lg={6}
                        md={6}
                        xs={12}
                        className={`text-center ${isEven ? "order-lg-1 order-md-1 order-1" : "order-lg-2 order-md-2 order-1"
                          }`}
                      >
                        <m.img
                          variants={imageVariants}
                          src={step.img}
                          className="how_work_img rounded-4 shadow-md"
                          alt={`step ${step.id}`}
                          style={{ maxWidth: "100%", height: "auto" }} // Ensure responsive
                          loading="lazy"
                          decoding="async"
                        />
                      </Col>
                    </div>
                  </div>
                </section>
              </m.div>
            );
          })}
        </Row>
      </Container>
    </LazyMotion>
  );
};

export default HowItWorks;
